import Vue from "vue"

import { mapGetters } from "vuex"

import helpers_utm_keys from "~/helpers/signup/utmKeys.js"

/*
 * STANDARD EVENT LIBRARY TYPES AND INTERFACES
 */
type StandardLibraryEventType = Record<
  string,
  (additionalContent: Record<string, any>, vm: any) => void
>
type AvailableStandardEventKeys = "ga" | "fb"
type AvailableEventKeys = AvailableStandardEventKeys | "am" | "intern"
type StandardEventTranslationLibrary = Record<
  AvailableStandardEventKeys,
  StandardLibraryEventType
>

/*
 * EVENT TYPES AND INTERFACES
 */
interface EventRequiredData {
  category: string
  action: string
  label: string | void
  previousUrl: string | void
  hash: string | void
}
type EventData = Record<string, any> & EventRequiredData
interface InternEventDetails {
  details: Record<string, any>
}
type InternDetails = InternEventDetails & EventData

export default Vue.extend({
  computed: {
    ...mapGetters({
      PREVIOUS_URL: "routing/PREVIOUS",
    }),
    translationLib(): StandardEventTranslationLibrary {
      return {
        ga: {
          purchase(additionalContent: Record<string, any>, vm: any) {
            const id = vm.$store.state.user.id + "__" + new Date().getTime()

            //@ts-ignore
            ga("ecommerce:addTransaction", {
              id: id,
              affiliation: additionalContent.label,
              revenue: additionalContent.value,
              shipping: 0,
              tax: 0,
              currency: "EUR",
            })
            //@ts-ignore
            ga("ecommerce:addItem", {
              id: id,
              name:
                additionalContent.pack_name || additionalContent.content_ids[0],
              price: additionalContent.value,
              quantity: 1,
              currency: "EUR",
            })
            //@ts-ignore
            ga("ecommerce:send")
          },
          completeRegistration(_: Record<string, any>, vm: any) {
            //@ts-ignore
            ga("send", {
              hitType: "event",
              eventCategory: "Signup",
              eventAction: "Signup Artist Succeeded",
              eventValue: vm.$store.state.user.id,
            })
          },
        },
        fb: {
          addPaymentInfo(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "AddPaymentInfo", additionalContent)
          },
          addToCart(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "AddToCart", additionalContent)
          },
          completeRegistration(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "CompleteRegistration", additionalContent)
          },
          initiateCheckout(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "InitiateCheckout", additionalContent)
          },
          purchase(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "Purchase", additionalContent)
          },
          search(additionalContent: Record<string, any>, _: any) {
            //@ts-ignore
            fbq("track", "Search", additionalContent)
          },
        },
      }
    },
    launchArr(): AvailableEventKeys[] {
      const ret: AvailableEventKeys[] = []

      //@ts-ignore
      if (typeof ga === "function") ret.push("ga")
      //@ts-ignore
      if (typeof fbq === "function") ret.push("fb")
      //@ts-ignore
      if (typeof amplitude === "object" && amplitude !== null) ret.push("am")
      ret.push("intern")
      return ret
    },
  },
  methods: {
    trackStandardEvent(
      actionName: string,
      _label: string,
      additionalContent: string
    ) {
      this.launchArr.forEach((eventType: AvailableEventKeys) => {
        if (
          //@ts-ignore
          this.translationLib[eventType] &&
          //@ts-ignore
          typeof this.translationLib[eventType][actionName] === "function"
        ) {
          //@ts-ignore
          this.translationLib[eventType][actionName](additionalContent, this)
        }
      })
    },
    build_query(data: EventData): EventData {
      for (const key in this.$route.query) {
        //@ts-ignore
        data[`query_${key}`] = this.$route.query[key]
      }
      return data
    },
    trackEvent(data: EventData) {
      if (typeof data === "object") {
        if (typeof data.label === "undefined") data.label = this.$route.path
        data = this.build_query(data)

        data.previousUrl =
          this.PREVIOUS_URL || window?.document?.referrer || undefined
        data.hash = this.$route.hash
        if (data.category && data.action) {
          this.internTrack({ ...data })
          this.amTrack(data)
        } else
          console.warn(
            "[EVENT]: Malformed event, probably missing action or category\n"
          )
      }
    },
    internTrack(data: EventData) {
      if (this.launchArr.includes("intern")) {
        const payload: InternDetails = {
          category: data.category,
          action: data.action,
          label: data.label,
          hash: data.hash,
          previousUrl: data.previousUrl,
          details: { ...data },
        }

        this.$axios
          .$post("/event/event/", {
            ...payload,
          })
          .catch((err) => {
            //@ts-ignore
            this.$sentry.captureException(err)
          })
      }
    },
    amTrack(data: EventData) {
      const category: string = data.category.toString()
      const amplitudeData: Record<string, any> = {
        ...data,
      }

      console.info(
        `[EVENT] : Emitting ${data.category} with action ${data.action}`
      )
      delete amplitudeData.category
      if (this.launchArr.includes("am")) {
        //@ts-ignore
        amplitude.getInstance().logEvent(category, { ...amplitudeData })
      }
    },
    createUserEvent(cookies: EventData) {
      //@ts-ignore
      const payload = {
        event_type: "signup",
        referer: cookies.get("referer"),
        ...helpers_utm_keys.reduce((accumulator: any, utmKey: any) => {
          const cookieValue = cookies.get(utmKey)

          if (typeof cookieValue === "string") accumulator[utmKey] = cookieValue
          return accumulator
        }, {}),
      }
      this.$axios.$post("/tracking/event/", payload, {
        headers: { "Content-Type": "application/json" },
      })
    },
  },
})
